import React, { forwardRef, useImperativeHandle, useRef } from "react"
import styled from "styled-components"
import Icon from "@/components/common/Icon/Icon"
import { ICONS } from "@/constants"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

const InputContainer = styled.div`
	display: flex;
	gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	padding-left: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	background-color: ${({ theme }) => theme.colors.white};

	&:not(&.disabled) {
		cursor: text;
	}

	.icon {
		width: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
		aspect-ratio: 1;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		gap: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
		.icon {
			width: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) and (orientation: landscape) {
		gap: ${getCssSizeValue(24)};
		.icon {
			width: ${getCssSizeValue(24)};
		}
	}
`

const Input = styled.input`
	width: 100%;
	border: unset;
	font-family: var(--font-borna);
	padding: ${getCssSizeValue(18, BREAKPOINTS.MOBILE)} 0;
	font-weight: 900;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(18, BREAKPOINTS.TABLET)} 0;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(18)} 0;
	}

	&::placeholder {
		font-weight: 400;
	}
`

const TextInput = forwardRef(function TextInput(
	{ name = "", className = "", icon = ICONS.LOUPE, onChange, value = "", containerClassName = "", disabled = false, ...props },
	fref,
) {
	const InputRef = useRef()

	const handleContainerClick = () => {
		InputRef.current.focus()
	}

	useImperativeHandle(fref, () => InputRef.current, [])

	return (
		<InputContainer
			onClick={handleContainerClick}
			className={`text-input-container ${containerClassName} ${disabled ? "disabled" : ""}`}
		>
			<Icon name={icon} />
			<Input
				ref={InputRef}
				className={`text-input typo-strawford-43 ${className}`}
				name={name}
				onChange={onChange}
				value={value}
				disabled={disabled}
				{...props}
			/>
		</InputContainer>
	)
})

export default TextInput
